import React, { Component } from "react";
import { Button } from "../forms/Form";
import { Link } from "react-router-dom";

export default class Submenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: false,
    };

    this.showMenu = this.showMenu.bind(this);
  }

  showMenu() {
    this.setState({ showMenu: !this.state.showMenu });
  }

  render() {
    return (
      <div
        className="submenu"
        style={{
          width: 220,
        }}
        onClick={this.showMenu}
      >
        <span>
          {this.props.leftIcon}{" "}
          <span
            style={{
              width: 80,
            }}
          >
            {this.props.username}
          </span>
          {this.props.rightIcon}
        </span>
        {this.state.showMenu ? (
          <div className="submenu-list">
            <Link to="/settings">Impostazioni account </Link>

            <a> Assistenza </a>
            <div className="button-container">
              <Button handleSubmit={this.props.logout} text={"ESCI"} />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
